// LLM generated - Model Claude 4 Sonnet
import { Paper, Flex, Skeleton, useMantineTheme, createStyles } from '@mantine/core';
import { IconChevronRight, IconReceipt } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import useBalanceWidget from '~/domains/account/components/BalanceWidget/useBalanceWidget';
import dt from '~/testing';

const useStyles = createStyles((theme) => ({
  paper: {
    width: '100%',
    padding: theme.spacing.lg,
    border: 'none',
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.dark[8],
    cursor: 'pointer',
    transition: 'all 0.2s ease',

    '&:hover:not(:disabled)': {
      backgroundColor: theme.colors.dark[7],
      transform: 'translateY(-1px)',
      boxShadow: theme.shadows.md,
    },

    '&:active:not(:disabled)': {
      transform: 'translateY(0px)',
    },

    '&:disabled': {
      opacity: 0.6,
      backgroundColor: theme.colors.gray[7],
      cursor: 'not-allowed',
    },
  },
}));

export type RefundableBalanceBoxProps = {
  refundableBalance: number;
  isLoading?: boolean;
  onClick: () => void;
  disabled?: boolean;
  title?: string;
};

export function RefundableBalanceBox({
  refundableBalance,
  isLoading = false,
  onClick,
  disabled = false,
  title,
}: RefundableBalanceBoxProps) {
  const { t } = useTranslation('payments');
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const { formatCurrency } = useBalanceWidget();

  const { dollars, cents } = formatCurrency(refundableBalance);

  const refundMessage = title || t('refund.balanceAvailable', { dollars, cents });

  return (
    <Skeleton visible={isLoading}>
      <Paper component="button" onClick={onClick} disabled={disabled} className={classes.paper}>
        <Flex align="center" justify="space-between">
          <Flex align="center" gap={theme.other.spacing._12}>
            <IconReceipt size={24} color={theme.white} />
            <Text
              data-test-id={dt.payments.withdrawal.components.refundableBalanceBoxText}
              variant="subhead-medium"
              c="white"
              fw={500}
            >
              {refundMessage}
            </Text>
          </Flex>
          <IconChevronRight size={20} color={theme.white} />
        </Flex>
      </Paper>
    </Skeleton>
  );
}
